var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M169.92 125.104c13.91-8.81 23.22-24.207 23.019-41.648C193.253 56.257 170.449 34 143.115 34H76.347v87.325c0 12.838-8.964 20.61-20.02 20.61-11.058 0-20.022-7.772-20.022-20.61V34H0v82.572C0 153.03 25.218 174 56.326 174c31.109 0 56.325-20.97 56.325-57.428V64.85h26.147c10.995 0 20.3 8.564 20.625 19.5.336 11.364-8.852 20.713-20.197 20.713H117.4l43.065 66.312H200z"
  })));
};
export default SvgLogo;